import React, { useState } from 'react';
import {
  applySubmission,
  detectFormType,
  lockFormForRole,
  makeReadOnly,
  prefillIdentity,
} from './feedbackFormBridge';

// The post-meeting feedback form is a static HTML file supplied by the client
// (public/babyreveal-feedback-forms.html), identical to the copy the web portal
// serves. It is never edited — a new drop from the client is copied straight
// over it — so everything shown below is applied to its live DOM at runtime.
const FEEDBACK_FORM_PATH = '/babyreveal-feedback-forms.html';

/* ── Read-only view of one submission ─────────────────────────────────────────
   Shows the client's own feedback HTML with a stored submission replayed into
   it, so the admin reads the answers in the same form the attendee filled in
   rather than a flat list. Everything is disabled and the submit button is
   removed, so it is a record, not an editable form.

   Pass `entry` as returned by GET /:id/feedback — { name, email, formType,
   answers }. Remount on a different entry (key by id) to reload the iframe.
─────────────────────────────────────────────────────────────────────────────── */
function FeedbackFormViewer({ entry, height = '70vh' }) {
  const [error, setError] = useState('');

  const onLoad = (event) => {
    const doc = event.target.contentDocument;
    if (!doc) {
      setError('This feedback could not be displayed.');
      return;
    }

    try {
      const formType = detectFormType(doc, entry?.answers, entry?.formType);
      const form = lockFormForRole(doc, formType);
      prefillIdentity(form, { name: entry?.name, email: entry?.email });
      applySubmission(form, entry?.answers);
      // Last, so the replayed `change` events still reach the file's own scripts.
      makeReadOnly(doc);
      setError('');
    } catch (e) {
      console.error('feedback form viewer', e);
      setError('This feedback could not be displayed in full.');
    }
  };

  return (
    <div>
      {error && <p style={{ color: '#b45309', fontSize: '0.82rem', marginBottom: 8 }}>{error}</p>}
      <iframe
        src={FEEDBACK_FORM_PATH}
        title={`Feedback from ${entry?.name || entry?.email || 'attendee'}`}
        onLoad={onLoad}
        style={{
          display: 'block',
          width: '100%',
          height,
          border: '1px solid #88A7B2',
          borderRadius: 8,
          background: '#FDF7F4',
        }}
      />
    </div>
  );
}

export default FeedbackFormViewer;
